// extracted by mini-css-extract-plugin
export default {"about":"about_about__OqO9f","header":"about_header__yWTvt","about-wrap":"about_about-wrap__RuH5w","sub-menu":"about_sub-menu__zme-o","active":"about_active__1qVnO"};